// CONSTANTS are all caps.
const NS = "HubGrid";
const CLS = "hubGrid";
const WG = "." + CLS + "-";

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/hubGrid.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class HubGrid {

	constructor($el) {
		// $el is the widget node return by the loadHubGrid function
		this.$el = $($el);
	}

	init() {
		this.setHubGrid();
	}

	setHubGrid() {
		// Add Some logic here
		const wg = this.$el,
			openBtn = wg.find(WG+'open');
		const closeBtn = wg.find(`${WG}close`);

		openBtn.on('click', function(e) {
			const item = $(this).parent().parent();
			item.addClass("hubGrid-item--opened");
		});

		closeBtn.on('click', function (e) {
			const item = $(this).parent().parent();
			item.removeClass('hubGrid-item--opened');
		});
	}

	//Add more functions like on above here

}
